module.exports = __webpack_public_path__ + "static/media/General-Information.688f803a.pdf";